import type { SearchPort } from '../domain/search'

const makeToggleSearch = (port: SearchPort) => () => {
	const current = port.get()
	port.set({ isOpen: !current.isOpen })
}

export { makeToggleSearch }
